import type { Product } from "../models/Product";
import type { ProductUnit } from "../models/Unit";
export const activeProductUnits = (product?: Product): ProductUnit[] => (product?.UnitPrices ?? []).filter(x => x.IsActive && Number.isFinite(x.BaseQuantity) && x.BaseQuantity > 0);
export const defaultProductUnit = (product?: Product) => {
    const defaults = activeProductUnits(product).filter(x => x.IsDefaultSaleUnit);
    return defaults.length === 1 ? defaults[0] : undefined;
};
export const sellingPrice = (unit?: ProductUnit, product?: Product) => unit?.DiscountedSellingPrice ?? (unit?.IsDefaultSaleUnit && (product?.DiscountedSellingPrice ?? 0)>0 ? product!.DiscountedSellingPrice : unit?.SellingPrice ?? 0);
export function validateProductUnits(product: Product): string {
    const units = product.UnitPrices ?? [];
    if (!product.BaseUnitCode)
        return "Select a base stock unit.";
    if (!units.length)
        return "Add at least one product unit.";
    const codes = new Set<string>();
    for (const unit of units) {
        if (!unit.UnitCode || codes.has(unit.UnitCode))
            return "Select a distinct unit on every row.";
        codes.add(unit.UnitCode);
        if (!Number.isFinite(unit.BaseQuantity) || unit.BaseQuantity <= 0)
            return "Conversion quantities must be greater than zero.";
        if (!Number.isFinite(unit.SellingPrice) || unit.SellingPrice <= 0)
            return "Selling prices must be greater than zero.";
        if (product.CostPrice != null && Number.isFinite(product.CostPrice) && unit.SellingPrice < product.CostPrice * unit.BaseQuantity)
            return `Selling price for ${unit.UnitCode} must be at least ${product.CostPrice * unit.BaseQuantity} (${unit.BaseQuantity} × base unit cost).`;
        if (unit.DiscountedSellingPrice != null && (!Number.isFinite(unit.DiscountedSellingPrice) || unit.DiscountedSellingPrice <= 0 || unit.DiscountedSellingPrice > unit.SellingPrice))
            return "Discounted prices must be greater than zero and no more than the selling price.";
        if (unit.UnitCode === product.BaseUnitCode && unit.BaseQuantity !== 1)
            return "The base stock unit must have conversion quantity 1.";
        if (unit.IsDefaultSaleUnit && !unit.IsActive)
            return "The default sale unit must be active.";
    }
    for (const unit of units.filter(u=>u.IsActive)) {
        if (product.CostPrice != null && sellingPrice(unit,product) < product.CostPrice * unit.BaseQuantity)
            return "The effective selling price after discount cannot be below cost.";
    }
    if (!units.some(x => x.UnitCode === product.BaseUnitCode && x.IsActive && x.BaseQuantity === 1))
        return "Add an active base stock unit with conversion quantity 1.";
    if (units.filter(x => x.IsDefaultSaleUnit && x.IsActive).length !== 1)
        return "Select exactly one active default sale unit.";
    return "";
}
